<div class="row g-0 my-bg-gradient text-white min-vh-100 w-100">
  <div class="col-7 pe-5 pt-5 login-col-left d-none d-xl-block">
    <img
      src="logo.svg"
      alt="Logo Blum Novotest"
      class="mb-4"
      style="width: 108px; height: 46px"
      priority />

    <h1 class="display-4 fw-bold mt-5">
      <span>your</span>
      <span class="title-magenta">Blum</span>
    </h1>
    <p class="lead">
      {{ "LoginSubcaption" | translate }}
    </p>
  </div>

  <div class="col-12 col-xl-5 pt-3 p-xl-5 login-col-right mx-auto">
    <div class="px-5 align-self-center">
      <div class="row">
        <div class="col d-xl-none mb-5">
          <img
            src="logo.svg"
            alt="Logo Blum Novotest"
            class="mb-4"
            style="width: 108px; height: 46px"
            priority />

          <h1 class="display-4 fw-bold mt-5">
            <span>your</span>
            <span class="title-magenta">Blum</span>
          </h1>
        </div>
        <div class="col">
          <app-language-picker
            class="d-flex justify-content-end"
            [displayAsButton]="true" />
        </div>
      </div>

      <div class="d-lg-none mb-3">
        <p class="lead">
          {{ "LoginSubcaption" | translate }}
        </p>
      </div>

      <h2 class="mt-4 mb-4 fw-bold">{{ "Login" | translate }}</h2>

      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        novalidate
        class="needs-validation">
        <div class="mb-3">
          <app-form-input
            [label]="'EmailAddress' | translate"
            controlName="email"
            inputType="email"
            autocomplete="email"
            [formgroup]="loginForm"
            [validationIsRequired]="true">
          </app-form-input>
        </div>
        <div class="mb-4">
          <app-form-input
            [label]="'Password' | translate"
            controlName="password"
            inputType="password"
            [formgroup]="loginForm"
            autocomplete="current-password"
            [validationIsRequired]="true"
            [passwordVisible]="passwordVisible">
          </app-form-input>
        </div>

        @if (requires2fa()) {
          <div class="mb-4">
            <app-form-input
              [label]="'TwoFactorAuthentication' | translate"
              controlName="tfa"
              [formgroup]="loginForm"
              [validationMaxLength]="11"
              [validationMinLength]="6"
              [alwaysShowValidationFeedback]="true"
              tooltipTextTranslationKey="TooltipTextTfa">
            </app-form-input>
          </div>
        }

        <div class="row gx-3 gy-0 mb-2">
          <div class="col col-sd-12 form-check">
            <input
              formControlName="passwordRemember"
              class="form-check-input"
              type="checkbox"
              id="loginSavePassword" />
            <label
              class="form-check-label"
              for="loginSavePassword">
              {{ "RememberPassword" | translate }}
            </label>
          </div>
          <div class="col col-sd-12 text-end">
            <a routerLink="/forget-password">
              {{ "ForgotYourPassword" | translate }}
            </a>
          </div>
        </div>

        <div class="d-grid gap-2 mb-4">
          <button
            type="submit"
            class="btn btn-primary my-3 text-white"
            [disabled]="submitting() || loginForm.invalid">
            {{ "Login" | translate }}
          </button>
        </div>
      </form>

      <div class="text-center">
        {{ "NoAccountYet" | translate }}
        <a routerLink="/registration">{{ "RegisterHere" | translate }}</a>
      </div>

      <div class="separator my-4">{{ "Or" | translate }}</div>

      <div class="text-center">
        {{ "StartA" | translate }}
        <a
          routerLink="/repair-request"
          class="action"
          data-bs-toggle="tooltip"
          [attr.title]="'TooltipTextIntroductionText' | translate">
          {{ "ReturnShipmentLoginLink" | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
